import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import {
  FDPaper, FDContentContainer, FDTitleText, FDBox,
} from '@facet-wealth/design';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Accordion from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Accordion';
import AccordianSummary from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionSummary';
import AccordionDetails from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CollapsibleDisclaimer from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import { PercentFormatter } from 'Helpers/Formats';
import {
  OurInterestComparedWithNationalAverage,
} from 'Components/ComponentLibrary/Organisms/OurInterestComparedWithNationalAverage';

const useStyles = makeStyles((theme) => ({
  exampleContainer: {
    backgroundColor: theme.palette.facet.lightGray,
    padding: theme.spacing(4),
  },
  accordion: {
    boxShadow: 'none',
    width: '100%',
  },
}));

const Content = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const [expandedFAQ, setExpandedFAQ] = useState();

  const classes = useStyles();

  const apy = `${PercentFormatter.format(resource.attr('apy'))}% APY`;

  return (
    <>
      <PageContentContainer>
        <PageContentTop
          title={resource.attr('title')}
        />
        <Text
          variant={'h1'}
          weight={'extraBold'}
          color={'naturalGreen'}
          text={apy}
        />
        {resource.attr('subtitle').map(text => (<Subtitle key={text} value={text} test={'wizard-step-subtitle'} />))}
      </PageContentContainer>

      <div className={classes.exampleContainer}>
        <FDContentContainer maxWidth={'sm'}>
          <FDPaper padding={500} width={'100%'}>
            <OurInterestComparedWithNationalAverage resource={resource} />
          </FDPaper>
        </FDContentContainer>
      </div>

      <PageContentContainer>
        <FDBox>
          {resource.attr('faq').resources().list().map(faq => (
            <Accordion
              key={faq.id()}
              expanded={expandedFAQ === faq.id()}
              onChange={(_, isExpanded) => setExpandedFAQ(isExpanded ? faq.id() : false)}
              classes={{
                root: classes.accordion,
                expanded: classes.accordionExpanded,
              }}
            >
              <AccordianSummary expandIcon={<ExpandMoreIcon />}>
                <FDTitleText value={faq.attr('question')} />
              </AccordianSummary>
              <AccordionDetails>
                {faq.attr('answer')}
              </AccordionDetails>
            </Accordion>
          ))}
        </FDBox>

        <CollapsibleDisclaimer
          disclaimerText={resource.attr('disclaimer')}
          disclaimerReadMore={resource.attr('expandedDisclaimer')}
        />
      </PageContentContainer>
    </>
  );
};

export default Content;
